export default __webpack_public_path__ + "static/12-728189386c37d304d46485bfc50fdc20.jpg";